

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {ICommunicationMessage} from "@/model/Communication/ICommunicationMessage";
import CommunicationMessages from "@/components/communications/widget/CommunicationMessages.vue";

  @Component({
    name: 'OOCommunicationMessages',
    components: {
      CommunicationMessages
    }
  })
  export default class OOCommunicationMessages extends Vue {

    @Prop()
    protected orderConfirmed!: boolean;
    @Prop()
    protected orderClosed!: boolean;
    @Prop()
    protected sendsCommunications!: boolean;
    @Prop()
    protected communicationMessages!: ICommunicationMessage[];
    @Prop()
    protected submitting!: boolean;
    @Prop({ default: null })
    protected timezone!: string | null;

    protected expanded: boolean = false;

    protected get showResend(): boolean {
      return this.orderConfirmed && !this.orderClosed;
    }

    protected onToggle() {
      this.expanded = !this.expanded;
    }

    protected onResendConfirmation(ev: Event) {
      this.$emit('resendConfirmation');
      ev.stopPropagation();
    }

  }

